import React, { ReactNode } from 'react'
import { Box, Paper, useTheme } from '@mui/material'

export const PaperWrapper: React.FC<{
  children: ReactNode
  includeBox?: boolean
}> = ({ children, includeBox }) => {
  const theme = useTheme()

  const Wrapper: React.FC<{ children: ReactNode }> = ({ children }) => (
    <Box sx={{ p: 5 }}>{children}</Box>
  )

  return (
    <Paper
      elevation={2}
      sx={{
        maxWidth: 700,
        minWidth: 350,
        pb: 2.5,
        minHeight: theme.spacing(50)
      }}
    >
      {includeBox ? <Wrapper>{children}</Wrapper> : children}
    </Paper>
  )
}
